import React, { FC, useCallback } from 'react';
import { FormattedMessage } from 'react-intl';
import { useDispatch } from 'react-redux';
import { messages } from '../../../../../i18n';
import { useOptions, useConfig } from '../../../../../selectors';
import { updateOptions } from '../../../../../actions';
import { useAnalytics } from '../../../../../hooks/useAnalytics';
import { getPublicId } from '../../../../../utils';
import { SmallSelectables } from '../../../common/selectable/containers/SmallSelectabes';
import { SelectableLogo } from '../../../common/selectable/logo/SelectableLogo';
import { TextLine } from '../../../common/TextLine';

export const Logos: FC = () => {
  const analytics = useAnalytics();
  const dispatch = useDispatch();
  const config = useConfig();
  const { selectedThemeIndex, selectedLogoIndex } = useOptions();
  const selectedTheme = config.themes[selectedThemeIndex];

  const handleLogoClick = useCallback((index: number, logoPublicId: string) => {
    analytics('edit look and feel', `${logoPublicId} logo`);
    dispatch(updateOptions({ selectedLogoIndex: index }));
  }, [analytics, dispatch]);

  return (
    <div>
      <TextLine>
        <FormattedMessage {...messages['section.lookAndFeel.logo']} />
      </TextLine>
      <SmallSelectables data-test="logos-container">
        {selectedTheme?.logos.map((logoName, index) => {
          const logoPublicId = getPublicId('logo', config, selectedThemeIndex, logoName);
          return (
            <SmallSelectables.Item key={logoPublicId}>
              <SelectableLogo
                isSelected={selectedLogoIndex === index}
                onClick={() => handleLogoClick(index, logoPublicId)}
                publicId={logoPublicId}
                data-test={`logo-${selectedLogoIndex}`}
              />
            </SmallSelectables.Item>
          );
        })}
      </SmallSelectables>
    </div>
  );
};
